import { render, staticRenderFns } from "./AdminManageSpecialistNameModal.vue?vue&type=template&id=a9c6c222"
import script from "./AdminManageSpecialistNameModal.vue?vue&type=script&lang=js"
export * from "./AdminManageSpecialistNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports